import { supabase } from '../../shared/supabase/supabaseClient';

/** Cuenta productos con stock bajo en Supabase (hub sin SQLite sincronizado). */
export async function countRemoteLowStockByBranch(branchId: string): Promise<number | null> {
  const { data, error } = await supabase.schema('inventory').rpc('count_branch_low_stock_skus', {
    p_branch_id: branchId,
  });

  if (error) {
    console.warn('[owner-panel] countRemoteLowStockByBranch', error.message);
    return null;
  }

  return typeof data === 'number' ? data : Number(data ?? 0);
}
